export const isCloudinaryUrl = (url: string): boolean => {
  try {
    const urlObject = new URL(url);
    const cloudinaryHost = process.env.NEXT_PUBLIC_CLOUDINARY_HOSTNAME;
    return urlObject.hostname === cloudinaryHost;
  } catch {
    return false;
  }
};
